import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonCol, IonRow, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonGrid } from '@ionic/react';
import { useParams } from 'react-router';
import ExploreContainer from '../components/ExploreContainer';
import { Descriptions, Row, Col, notification, Table, Tag } from 'antd';
import { Card } from 'antd';
import { Switch } from 'antd';
import { Input } from 'antd';
import moment from 'moment';
import { PageHeader } from 'antd';
import { Form, Checkbox } from 'antd';

import { DatePicker, Space, Button } from 'antd';

import React, { useState } from 'react';
import { Link } from 'react-router-dom';


const ForgotPassword: React.FC = (props:any) => {
    const { name } = useParams<{ name: string; }>();


    const layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    }

    const tailLayout = {
        wrapperCol: { offset: 8, span: 16 },
    }

    const Demo = () => {
        const onFinish = (values: any) => {
            console.log('Success:', values);
        }
    }

        const onFinishFailed = (errorInfo: any) => {
            console.log('Failed:', errorInfo);
        }
    




    return (

        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonRow>
                        <PageHeader
                            className="site-page-header"
                            onBack={()=>{props.history.goBack()}}
                            title="Forgot Password"

                        />
                    </IonRow>
                </IonToolbar>
            </IonHeader>

            <IonContent fullscreen >
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="large">{name}</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <Space direction="vertical">
                    <IonGrid>
                        <IonRow>
                            <IonCol size="18" style={{ paddingLeft: "370px", paddingTop:"300px"}}>
                                <IonCard>
                                    <IonCardHeader>

                                    </IonCardHeader>

                                    <IonCardContent>
                                        <Form
                                            {...layout}
                                            name="basic"
                                            initialValues={{ remember: true }}
                                            onFinish={Demo}
                                            onFinishFailed={onFinishFailed}
                                        >
                                            <Form.Item
                                                label="Email"
                                                name="email"
                                                rules={[{ required: true, message: 'Please input your username!' }]}
                                            >
                                                <Input />
                                            </Form.Item>

                                            <Form.Item {...tailLayout}>
                                                <IonRow>
                                                    <IonCol>
                                                <Button type="primary" htmlType="submit">
                                                    Submit
                                                </Button>
                                                </IonCol>
                                                <IonCol>
                                                
                                                </IonCol>
                                                </IonRow>
                                            </Form.Item>
                                        </Form>
                                    </IonCardContent>
                                </IonCard>
                            </IonCol>
                        </IonRow>
                    </IonGrid>

                </Space>
            </IonContent>
        </IonPage>

    );
}

export default ForgotPassword;